import FieldsCollection from "../../../../core/fields3/collection/base/fields-collection";
import {EntityType} from "../../../../core/gd/const/item";
import {FieldType} from "../../../../core/fields3/field-type";
import FieldToggle from "../../../../core/fields3/generic/boolean/toggle/toggle";

const baseConfig = [
    {
        fieldId: 'projects',
        label: 'Projects',
        type: FieldType.TOGGLE
    },
    {
        fieldId: 'tasksByTitle',
        label: 'Tasks by Title',
        type: FieldType.TOGGLE
    },
    {
        fieldId: 'tasksByShortId',
        label: 'Tasks by Short ID',
        type: FieldType.TOGGLE
    },

    {
        fieldId: 'tasksClosed',
        label: 'Closed Tasks',
        type: FieldType.TOGGLE
    },

    {
        fieldId: 'documents',
        label: 'Documents',
        type: FieldType.TOGGLE
    },
    {
        fieldId: 'users',
        label: 'Users',
        type: FieldType.TOGGLE
    },
    {
        fieldId: 'modules',
        label: 'Modules',
        type: FieldType.TOGGLE
    },
    {
        fieldId: 'archivedTasks',
        label: 'Archived tasks',
        type: FieldType.TOGGLE
    }
]

export default class QuickSearch_Fields extends FieldsCollection {

    constructor() {
        super(baseConfig, EntityType.DYNAMIC_MODEL)
    }

    get tasksByTitle() { return this.get('tasksByTitle') as FieldToggle }
    get tasksByShortId() { return this.get('tasksByShortId') as FieldToggle }
    get tasksClosed() { return this.get('tasksClosed') as FieldToggle }

    get projects() { return this.get('projects') as FieldToggle }
    get documents() { return this.get('documents') as FieldToggle }
    get users() { return this.get('users') as FieldToggle }
    get modules() { return this.get('modules') as FieldToggle }

}